import profileImage from '../assets/images/Image_06.png';
import Plastic from "../assets/images/Image_003.png";
import PageHeader from '@/components/PageHeader';

function Publications() {
  return (
    <div className="font-sans">
      <PageHeader title='Publications' imageUrl={profileImage} breadcrumbs={['Home', 'Publications']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Publications
        </h2>

        <h3 className="text-sm font-bold text-[#05326D] flex items-center gap-2 mt-12 mb-4">
          <span className="inline-block w-[6px] h-5  rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Can we reduce plastics usage in pharmaceutical industry? – Think
        </h3>


        <ul className="list-none text-sm space-y-2 text-[#05326D] mb-8">
          <li className="flex items-center space-x-2">
            <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block"></span>
            <span>Plastics and Environment – Frankenstein</span>
          </li>
          <li className="flex items-center space-x-2">
            <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block"></span>
            <span>Food – any food, outside home we eat in Junk food</span>
          </li>
          <li className="flex items-center space-x-2">
            <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block"></span>
            <span>Chemical based drugs (Allopathic drugs): Biggest Challenge for Human Health – Publicised Wildly and Widely</span>
          </li>
          <li className="flex items-center space-x-2">
            <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block"></span>
            <span>World peace and no wars</span>
          </li>
          <li className="flex items-center space-x-2">
            <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block"></span>
            <span>Artificial Intelligence (AI) – Only acclaimed</span>
          </li>
        </ul>

        {/* Changed items-start to items-end here */}
        <div className="flex flex-col md:flex-row items-end gap-8">
          <div className="order-1 md:order-none md:w-2/3 text-sm text-[#05326D] space-y-6">
            <p>
              Except the first topic rest are not going to have any solution and they are apparently having no end either. They
              will be only discussed at all the levels on global platforms and are on the top of agenda for all future meetings,
              conferences, conclaves, seminars, workshops and political forums.
            </p>
            <p>
              Can you imagine the life without RUBBER BANDS, CELLO TAPE, BOPP TAPES and STAPLER PINS? These used to be
              important accessories in offices (before E-age) and now these are available in abundance in any shop, hawkers,
              vendors, on-line shopping outlets and household. The life without above seems to be impractical if not
              impossible. One may find it unimaginable to live without these.
            </p>
            <p>
              We definitely cannot have everything INSTANT – make when you need and use the same. In the present-day world,
              we have to have inventories, stocks and logistics in place for immediate delivery/ availability. Seeing the nature
              and the need of any item the packaging, storage and transport worthiness add much more to the actual cost of
              the goods. All the health experts and nutrition specialists keep on talking big but spices ads are given by
              celebrities only. Every week there is a new restaurant or food joint or street food stall and even drug stores and
              retail outlet in every suburb of metro cities.
            </p>
            <p>
              The new generation may not be able to imagine life without any of the above first three, as far as the war and
              peace are concerned, it is strategic so let average minds not bother for it. I am not convinced that the food and
              drugs must be criticised or condemned. The need of drugs and food is universal and the food habit vary from
              place to place. Generally, what we eat cannot be UNSAFE. It is the matter of quantity, ways and means of cooking
              and the additives. If under control and scientifically (rather biologically) managed no food must be labelled as
              Junk.
            </p>
            <p>
              Similarly, there appears to be a war waged and meticulously patronised by the lobbies that control the national
              economy and political power, amongst various medicine systems in the country. The situation is like CHOR SE
              KAHE TU CHORI KAR AUR SAAH SE KAHE TU JAAGTE RAHIYE (To run with the hare and hunt with the hounds). I am
              not dwelling on this subject for long because my focus is something which is impacting our life to a level beyond
              control. The above two matters can be managed and ae very much understood by the consumers, their discretion
              and preference will make a big difference. Those born after 1980 may find everything historical and imaginary and
              may think, for times immemorial plastics of various types have been the only material available for storage,
              cooking, packaging, creating fashion, for electronics and even for construction of the houses. Look at the
              surroundings it is all plastics, technically people may call it polymers of various types, grades and chemical
              composition. I was very much convinced by an advertisement where the housing units of future will have no
              kitchen or grocery storage except heating or warming devices and the refrigeration units will be of the room size.
              This talks about the packaging, storage and transportation for the future.
            </p>
            <p>
              Suddenly there has been serious awareness about the environment, pollution, safety, health hazards, ailments
              related to plastics (rather chemicals) and there has been a talk of green revolution once again. People are moving
              towards organic crops of cereals, fruits and vegetables. They are switching to Vegan food style. Now it is not a
              religious thought but a philosophy to go towards the nature and protect the gradual decay leading to global
              warming and deterioration of human health with unknown diseases and new symptoms of impaired health. India
              still has the advantage compared to western world regarding disposable and reusable packaging components.
              This generates less of waste to be disposed or subject to destruction. I am talking about this situation way back in
              2010, it was being discussed in Florida US in a convention where I too participated.
            </p>
            <p>
              My concern is mainly for processing and handling of the drugs and pharmaceuticals, doesn’t matter be it
              Allopathic or Ayurvedic or Homeopathic. Most of us in our 50s might know it used to be mainly metals, glass or
              paper being abundantly used for processing, storage, dispensing, packaging and transportation of the drug
              products. The factors like handling, weigh, freight, breakage, convenience and user-friendly attributes drew the
              attention of scientists, chemical engineers and packaging experts to develop and evolve the safe alternatives. The
              focus was obviously the speed, volume, cleanliness, cost, availability, transportation and stability of the drug
              products.
            </p>
            <p>
              Today, if we can assess then we might be surprised that the variety of plastics we use in pharmaceutical industry is
              phenomenal. Unfortunately, all these are used for one single time and are to be discarded, disposed or subjection
              to destruction. I am afraid if the recycling of any type of plastics generated in the pharma industry is possible or
              recommended.
            </p>
            <p>
              The usage of plastics in the pharmaceutical operations starting from the raw materials packaging and
              transportation to the finished product (formulation) delivery to the consumer/patient is humongous. PE bags of
              various capacities 5 g to 50 kg, hand gloves, half a dozen variety of tapes, disposable footwears, disposable
              overalls for the clean areas and all sorts of bottles and lab utilities. LDPE, HDPE, PVC, PET, Nylon, Silicon, viscose,
              Teflon, blister films of various types, shrink films, poly-laminated films, lamination, FFS granules etc. I can keep on
              adding even to the medical devices. Imagine the waste generated in the pharmaceutical companies and the
              hospitals every day. Those having worked in manufacturing of pharmaceutical products and hospitals would know
              this. After the food packaging and the cosmetics & toiletries, pharma industry (nutritional products excluded) and
              health/hospital/medical accessories (syringes, tubing, plasters, infusion bottles etc.) is the largest consumer of
              plastics.
            </p>
            <p>
              In this era of awareness towards health, environment, carcinogenicity, hypersensitivity and the non-stop reports of
              presence of plastic particles/fibres in the human system, there is a need to evolve safer and better alternatives. I
              understand business, cost, convenience, safety, fragility and weight considerations cannot be overlooked or
              sidetracked but the need for safety on a long-term basis also cannot be ignored or compromised. Let the science
              and technology work on this important matter.
            </p>
          </div>

          <div className="order-2 md:order-none md:w-1/3 w-full mt-8 md:mt-0">
            <img
              src={Plastic}
              alt="Plastic in Pharma"
              className="w-full h-auto object-contain mx-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Publications;
